import React from 'react';
import { Link } from 'react-router-dom';

// Storage can throw outright in some private modes; a footer is no reason to crash
const isSignedIn = () => {
  try {
    return !!localStorage.getItem('auth-token');
  } catch (e) {
    return false;
  }
};

// The public profile's footer, inside the page so it takes the profile's text
// colour and sits below the last link rather than over it. Mirrored in
// src/profileView.js.
const Footer = () => {
  return (
    <footer className="profile-footer">
      {isSignedIn()
        ? <Link to='/admin'>link.piyanos.com</Link>
        // A plain anchor, not <Link>: `/` is the static marketing site, so this
        // has to be a real request rather than a client-side route change.
        : <a href='/'>link.piyanos.com</a>}
    </footer>
  )
}

export default Footer
